/**
 * Infer a country code from the browser's timezone.
 * Falls back to navigator.language if no timezone match.
 */

const TIMEZONE_TO_COUNTRY: Record<string, string> = {
  // US
  "America/New_York": "US", "America/Chicago": "US", "America/Denver": "US",
  "America/Los_Angeles": "US", "America/Phoenix": "US", "America/Anchorage": "US",
  "Pacific/Honolulu": "US",
  // AU
  "Australia/Sydney": "AU", "Australia/Melbourne": "AU", "Australia/Brisbane": "AU",
  "Australia/Perth": "AU", "Australia/Adelaide": "AU", "Australia/Hobart": "AU",
  "Australia/Darwin": "AU",
  // GB
  "Europe/London": "GB",
  // CA
  "America/Toronto": "CA", "America/Vancouver": "CA", "America/Edmonton": "CA",
  "America/Winnipeg": "CA", "America/Halifax": "CA", "America/St_Johns": "CA",
  // NZ
  "Pacific/Auckland": "NZ", "Pacific/Chatham": "NZ",
  // DE
  "Europe/Berlin": "DE",
  // FR
  "Europe/Paris": "FR",
  // IE
  "Europe/Dublin": "IE",
  // IN
  "Asia/Kolkata": "IN", "Asia/Calcutta": "IN",
  // SG
  "Asia/Singapore": "SG",
  // JP
  "Asia/Tokyo": "JP",
};

const LOCALE_PREFIX_TO_COUNTRY: Record<string, string> = {
  en: "US", de: "DE", fr: "FR", ja: "JP", hi: "IN",
};

export function inferCountryCode(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIMEZONE_TO_COUNTRY[tz]) return TIMEZONE_TO_COUNTRY[tz];
  } catch { /* ignore */ }

  try {
    const lang = navigator.language;
    // Check full locale first (e.g. en-GB → GB)
    const region = lang.split("-")[1]?.toUpperCase();
    if (region && region.length === 2) return region;
    // Fall back to language prefix
    const prefix = lang.split("-")[0].toLowerCase();
    if (LOCALE_PREFIX_TO_COUNTRY[prefix]) return LOCALE_PREFIX_TO_COUNTRY[prefix];
  } catch { /* ignore */ }

  return "US";
}
